import { useEffect } from 'react';
import classNames from 'classnames';
import { Col } from '@guestyci/foundation/Layout';
import TextField from '@guestyci/foundation/TextField';
import createStyles from '@guestyci/foundation/createStyles';
import utils from 'utils';
import track from 'utils/dio/login-page';
import Layout from 'app/shareable/layouts/Layout';
import LoginForm from 'app/module/Authorization/LoginForm';
import useCustomTextFieldStyles from 'app/shareable/theme/useCustomTextFieldStyles';

const useStyles = createStyles({
  title: {
    fontSize: '3em',
    fontWeight: 700,
  },
});

export default function LoginPage() {
  const classes = useCustomTextFieldStyles();
  const styles = useStyles();

  useEffect(() => {
    track.viewLoginPage();
  }, []);

  useEffect(() => {
    utils.clearSessionData();
  }, []);

  return (
    <Layout iframeUrl="https://www.guesty.com/app-gfh-animation/">
      <Col>
        <div className="text-center mb-12">
          <TextField className={classNames(classes.h1, styles.title)}>
            Welcome Back!
          </TextField>
          <div className="mt-2">
            <TextField className={classes.h3}>
              Please enter your details below to log in.
            </TextField>
          </div>
        </div>

        <LoginForm />
      </Col>
    </Layout>
  );
}
